import script from "./ScoreGate.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreGate.vue?vue&type=script&setup=true&lang=js"

import "./ScoreGate.vue?vue&type=style&index=0&id=106a6c82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106a6c82"]])

export default __exports__